import React from "react";
import { Dialog } from "../containers/Dialog.tsx";
import { Button } from "../widgets/Button.tsx";
import { Banner } from "../widgets/Banner.tsx";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  infoMessage?: string;
  warningMessage?: string;
  dangerMessage?: string;
  confirmText?: string;
  cancelText?: string;
  variant?: "danger" | "warning" | "info";
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  infoMessage,
  warningMessage,
  dangerMessage,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "danger",
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} title={title}>
      <Dialog.Content>
        <div className="flex flex-col gap-2">
          {(infoMessage || warningMessage || dangerMessage) && (
            <Banner
              variant={
                dangerMessage ? "error" : warningMessage ? "warning" : "info"
              }
              title={
                dangerMessage
                  ? "Not Allowed"
                  : warningMessage
                    ? "Warning"
                    : "Notice"
              }
              visible
              body={dangerMessage ?? warningMessage ?? infoMessage}
            />
          )}
          <p className="text-gray-700">{message}</p>
        </div>
      </Dialog.Content>
      <Dialog.Actions>
        <Button variant="neutral" onClick={onClose}>
          {cancelText}
        </Button>
        <Button
          variant={
            variant === "danger" || variant === "warning" ? "danger" : "submit"
          }
          onClick={handleConfirm}
          disabled={!!dangerMessage}
        >
          {confirmText}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export { ConfirmDialog };
